import { DownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import classNames from 'classnames';
import { not } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { Components } from '@fasstech/flexiget';

const ElementsBar = ({
  title,
  children,
  info,
  isClosed,
  setIsClosed,
  className
}) => {
  return (
    <div className={classNames('bg-white p-4', className)}>
      <div
        className="flex"
      >
        <div
          className={classNames('btn-close-elements flex items-center justify-between min-h-50px w-full', { 'cursor-pointer': isNotNilOrEmpty(isClosed) })}
          onClick={() => setIsClosed && setIsClosed(not(isClosed))}
        >
          <div className="flex text-flexi-text uppercase text-xs font-bold relative">
            {title}
            {info && (
              <Components.Tooltip title={info}>
                <InfoCircleOutlined className="ml-1 cursor-pointer" />
              </Components.Tooltip>
            )}
          </div>
          {isNotNilOrEmpty(isClosed) && (
            <DownOutlined
              className={classNames('text-flexi-text text-medium', { 'rotate-180 mb-1': isClosed })}
            />
          )}
        </div>
      </div>
      <div className="flex justify-center">
        {children}
      </div>
    </div>
  );
};

export default ElementsBar;
